<template>
    <div class="d-flex align-center mt-1" >
        <v-btn @click="previousMonth()" small text color="success">
        <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div>
        <span class="font-weight-light grey--text text-capitalize headline">{{this.$store.state.reportMonth}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="nextMonth()" small text  color="success">
        <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    nextMonth(){
      this.$store.dispatch("addMonthToReportDate");
    },
    previousMonth(){
      this.$store.dispatch("removeMonthFromReportDate");
    }
  },
  computed: {
  },
  mounted () {
  },
  created(){
  },
  watch: {

  }
}
</script>
<style scoped>
</style>
